import { render, staticRenderFns } from "./PrizesPayments.vue?vue&type=template&id=8cb51014&scoped=true&"
import script from "./PrizesPayments.js?vue&type=script&lang=js&"
export * from "./PrizesPayments.js?vue&type=script&lang=js&"
import style0 from "./PrizesPayments.scss?vue&type=style&index=0&id=8cb51014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb51014",
  null
  
)

export default component.exports